import { render, staticRenderFns } from "./config-banner.vue?vue&type=template&id=52c9c73c&scoped=true"
import script from "./config-banner.vue?vue&type=script&lang=ts"
export * from "./config-banner.vue?vue&type=script&lang=ts"
import style0 from "./config-banner.vue?vue&type=style&index=0&id=52c9c73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c9c73c",
  null
  
)

export default component.exports